import Toll from "../../../../../services/toll";
import C from '../../../../common/constantes';
import messageDialog from "../../../../../components/message-dialog";
import Tolls from "../../../../../services/toll";
import TransportadorRntrc from "./transportador-rntrc.vue";
import {cpfCnpj} from "../../../../../validators/cpfCnpj";

export default {
  components: {TransportadorRntrc},
  props: ['aggregate', 'contract'],
  data() {
    return {
      loading: undefined,
      plate: undefined,
      axesId: 2,
      msgError: undefined,
      msgErrorBold: undefined,
      vehicle: this.aggregate || undefined,
      contractAggregate: undefined,
      enableRNTRC: false,
      showTranportadorRntrc: false,
      transportadorRntrc: undefined,
      rntrcDocument: undefined,
      rntrcOwnerName: undefined
    }
  },
  watch: {
    plate(value){
      if(value.length < 8)
        return false;
      else
        this.findPlate();
    },
    axesId(newVal) {

      this.vehicle.categoryAxesId = newVal;
      this.vehicle.categoryArtespId = newVal;
      this.vehicle.category = this.category;
    }
  },
  computed: {
    axes(){
      return C.Axes;
    },
    category(){
      return _.find(C.Axes, (o)=>{
        return o.category_artesp_id == this.axesId;
      }).caption;
    },
  },
  methods: {
    findPlate(){
      this.msgError = undefined;
      this.loading = Toll.getVehicleDataVp(this.plate).then(r => {
        this.vehicle = r;
        // this.axesId = r.categoryArtespId;
        // this.vehicle.category = this.axesId;
        //
        this.$emit('aggregateData', this.vehicle);
        this.msgError = undefined;
        this.msgErrorBold = undefined;
      }).catch(err => {
        this.$emit('aggregateData', undefined);

        if(err.data.status &&
          (
            err.data.status.code === 9203 ||
            err.data.status.code === 9205 ||
            err.data.status.code === 9209 ||
            err.data.status.code === 9210 ||
            err.data.status.code === 9223 ||
            err.data.status.code === 9225
          )
        ){
          this.showTranportadorRntrc = true
          this.enableRNTRC = true;
          this.msgError = err.data.status.message;
          return;
        } else {
          if(err.data.status.code === 9883) {
            this.msgErrorBold = 'Placa não encontrada!'
            this.msgError = 'Faça uma nova busca ou cadastre o Agregado.';
          } else {
            this.msgError = err.data.status.message;
          }
          this.vehicle = undefined;
        }
      });
    },

    cancelRNTRC() {
      this.enableRNTRC = false;
      this.rntrcDocument = '';
      this.rntrcOwnerName = '';
    },

    validateDocument() {
      if (!this.rntrcDocument) {
        this.msgError = 'Favor informar CPF/CNPJ.';
        return;
      }

      if (!cpfCnpj.validate(this.rntrcDocument)) {
        this.msgError = "Documento inválido!";
        return;
      }

      this.loading = Tolls.getVehicleDataVp(this.plate, this.rntrcDocument).then(response => {

        this.vehicle = response;
        this.enableRNTRC = false;
        this.$emit('aggregateData', this.vehicle);
        this.msgError = undefined;
        this.msgErrorBold = undefined;

      }).catch(err => {
        this.msgError = err.data.status.message;
      });
    }

  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/toll-ticket/vehicle-aggregate.js